import axios from 'axios'
import {apiBaseUrl} from '../../../helpers/UrlHelper'
import {loginToken} from '../../../helpers/LocalStorageHelper'
import {handleError, handleSuccess} from '../../../helpers/ErrorHelper'
import store from '../../../Store'
import {scrollToError} from '../../../helpers/ScrollHelper'
import {
    cancelPriceFormDispatch,
    priceFormServerValidationErrors
} from "../../../pages/price/form/PriceForm-Action";

function _success(success) {
    return {type: 'UPDATE_PRICE_SUCCESS', success}
}

function _error(error) {
    return {type: 'UPDATE_PRICE_ERROR', error}
}

function _processing(processing) {
    return {type: 'UPDATE_PRICE_PROCESSING', processing}
}

function updatePrice(id) {
    return (dispatch, getState) => {

        let {priceForm} = getState()
        dispatch(_success(null))
        dispatch(_error(null))
        dispatch(_processing(true))

        axios({
            url: apiBaseUrl(`admin/global_prices/${id}`),
            method: 'put',
            dataType: 'json',
            data: priceForm.data.payload,
            headers: {
                'Authorization': 'Bearer ' + loginToken()
            }
        })
            .then(function (res) {
                dispatch(_success(res))
                dispatch(_processing(false))
                handleSuccess(res)
                store.dispatch(cancelPriceFormDispatch())

            }).catch(function (error) {
            dispatch(_error(error.response.data.message))
            dispatch(_processing(false))
            handleError(error)

            store.dispatch(cancelPriceFormDispatch())
            if (error.response && error.response.status === 422) {
                store.dispatch(priceFormServerValidationErrors(error.response.data.errors))
                scrollToError()
            }
        })
    }
}

export default updatePrice
